export const PACKAGE = 'PACKAGE'